import React, { useEffect, useState } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  TextField
} from "@material-ui/core";
import useStyles from "./styles";
import { AdminUser, Authenticated } from "../../../../models/User";
import * as managerApi from "../../../../api/personApi";
import { isOk } from "../../../../result";
import { SettingsChildrenProps } from "./SettingsDialog";
import Alert from "@material-ui/lab/Alert";
import { useI18n } from "../../../../hooks/useI18n";

export const Profile = ({ onSuccess }: SettingsChildrenProps) => {
  const classes = useStyles();
  const [state, setState] = useState({} as Authenticated);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const { t } = useI18n();

  const confirm = async () => {
    setShowError(false);
    setIsUpdateLoading(true);

    const result = await managerApi.updateProfile(state as AdminUser);
    if (isOk(result)) {
      onSuccess();
    } else {
      setShowError(true);
    }
    setIsUpdateLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    managerApi.getProfile().then(r => {
      if (isOk(r)) {
        setState(r.value);
        setIsLoading(false);
      }
    });
  }, []);

  const validatePhoneNumber = (phone: string) => {
    const regex = /^[+]{1}[0-9]{9,}$/;

    return !(phone && phone.match(regex));
  };

  return (
    <DialogContent>
      {isLoading && (
        <div className={classes.spinnerContainer}>
          <CircularProgress />
        </div>
      )}
      <Container>
        <Grid item container className={classes.center}>
          <Box sx={{ width: "100%" }}>
            <TextField
              style={{ flex: 1 }}
              className={classes.field}
              label={t("common.formFields.name")}
              value={state?.name ?? ""}
              onChange={(e: any) => {
                setState({
                  ...state,
                  name: e.target.value
                });
              }}
            />
            <TextField
              style={{ flex: 1 }}
              className={classes.field}
              label={t("common.formFields.email")}
              value={state?.email ?? ""}
              onChange={(e: any) => {
                setState({
                  ...state,
                  email: e.target.value
                });
              }}
            />
            <TextField
              helperText={"Format: +46701234567"}
              error={validatePhoneNumber(state.phoneNumber)}
              style={{ flex: 1 }}
              className={classes.field}
              label={t("common.formFields.phoneNumber")}
              value={state?.phoneNumber ?? ""}
              onChange={(e: any) => {
                setState({
                  ...state,
                  phoneNumber: e.target.value
                });
              }}
            />
          </Box>
        </Grid>
      </Container>
      <DialogActions style={{ padding: 0 }}>
        <Container>
          <Box pr={0} pb={1} mt={2} display={"flex"} justifyContent={"end"}>
            <Button
              onClick={confirm}
              color="primary"
              autoFocus
              variant={"contained"}
              disabled={
                isUpdateLoading || validatePhoneNumber(state.phoneNumber)
              }
            >
              Save
            </Button>
          </Box>
        </Container>
      </DialogActions>
      {showError && (
        <Alert severity="error">
          {t("common.messages.failedToSaveProfile")}
        </Alert>
      )}
    </DialogContent>
  );
};
